import React from 'react';
import './style.css';

// Helper function to map card string to image path
const getCardImageFromCode = (cardCode) => {
  if (!cardCode) return null;
  try {
    return `/assets/img/cards/${cardCode}.png`;
  } catch (e) {
    return null;
  }
};

// Helper function to parse rdesc
const parseRdesc = (rdesc) => {
  if (!rdesc) return {};
  
  const parts = rdesc.split('#');
  return {
    winner: parts[0] || "",
    oddEven: parts[1] || "",
    color: parts[2] || "",
    card: parts[3] || "",
    line: parts[4] || "",
  };
};

const Lucky7 = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  const cardImage = detailResult?.card ? getCardImageFromCode(detailResult.card) : null;
  const rdescData = detailResult?.rdesc ? parseRdesc(detailResult.rdesc) : {};
  const winner = detailResult?.winnat || rdescData.winner || "";

  return (
    <div className="row bottom-border-casino m-t-10">
      <div className="col-md-12">
        <div className="player-image-container row">
          <div className="text-center player-number col-12">
            <h6 className="text-right mb-3">
              <b>Round Id :</b> {roundId}
            </h6>
            {cardImage && (
              <img src={cardImage} alt="Winning Card" onError={(e) => e.target.style.display = 'none'} />
            )}
            <div className="col-md-12 text-left">
              {winner && (
                <p className="m-b-0 m-t-20">
                  <b>Winner:</b> {winner}
                </p>
              )}
              {rdescData.oddEven && (
                <p className="m-b-0">
                  <b>Odd/Even:</b> {rdescData.oddEven}
                </p>
              )}
              {rdescData.color && (
                <p className="m-b-0">
                  <b>Color:</b> {rdescData.color}
                </p>
              )}
              {rdescData.card && (
                <p className="m-b-0">
                  <b>Card:</b> {rdescData.card}
                </p>
              )}
              {rdescData.line && (
                <p className="m-b-0">
                  <b>Line:</b> {rdescData.line}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lucky7;

